import { LoadState } from "../../constants/enums";
import {
  IReviewQuestionnaireState,
  IReviewsQuestionnaire,
} from "./ReviewQuestionnaire.types";

export const defaultReviewsQuestionnaire: IReviewsQuestionnaire = {
  reviews_questionnaire_uuid: null,
  rating: null,
  questions: [
    {
      question: "",
      question_type: "SINGLE",
      options: [],
    },
  ],
  remarks: null,
  company_outlet_uuid: null,
  status: "ACTIVE",
};

export const defaultReviewQuestionnaireState: IReviewQuestionnaireState = {
  list: {
    data: [],
    totalRecords: 0,
    currentRecords: 0,
    loading: LoadState.InProgress,
    error: null,
  },
  questionnaire: {
    data: defaultReviewsQuestionnaire,
    loading: LoadState.NotLoaded,
    error: null,
  },
  qrCode: {
    base64: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
